module.exports = __webpack_public_path__ + "img/mp-flows-explorations.a3ce058d.jpg";